import React from 'react'
import { connect } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import Icon from 'blocks.simple/icon/icon'
import { cn } from 'ethcss'
import styles from './toast.jcss'
import type {
    ToastCloseButtonProps,
    ToastContent,
    ToastId,
    ToastOptions,
    ToastPosition,
    ToastProps,
    ReactToastOptions,
    ToastRootState,
} from './toast.types'

const defaultOptions: ReactToastOptions = {
    className: cn(styles.wrapper),
    closeOnClick: false,
}

const toastPositions: ToastPosition[] = [
    'top-right',
    'top-center',
    'top-left',
    'bottom-right',
    'bottom-center',
    'bottom-left',
]

const isToastPosition = (position: string | undefined): position is ToastPosition =>
    position !== undefined && toastPositions.includes(position as ToastPosition)

const getToastOptions = (options?: ToastOptions): ReactToastOptions => {
    if (!options) {
        return defaultOptions
    }

    const { autoClose, position, ...restOptions } = options

    return {
        ...defaultOptions,
        ...restOptions,
        ...(autoClose !== true && autoClose !== undefined ? { autoClose } : {}),
        ...(isToastPosition(position) ? { position } : {}),
    }
}

const CloseButton = ({ closeToast }: ToastCloseButtonProps) => (
    <div onClick={closeToast} style={{ padding: '4px 4px 0 0' }}>
        <Icon type="close" color="white" size={14} />
    </div>
)

class Toast extends React.PureComponent<ToastProps> {
    static info(item: ToastContent, options?: ToastOptions) {
        toast.info(item, getToastOptions(options))
    }
    static warn(item: ToastContent, options?: ToastOptions) {
        toast.warn(item, getToastOptions(options))
    }
    static error(item: ToastContent, options?: ToastOptions) {
        toast.error(item, getToastOptions(options))
    }
    static success(item: ToastContent, options?: ToastOptions) {
        toast.success(item, getToastOptions(options))
    }
    static default(item: ToastContent, options?: ToastOptions): ToastId {
        return toast(item, getToastOptions(options))
    }

    render() {
        const minimizeWidth = this.props.minimizeMenu ? 'Toastify__toast-container--bottom-left_minimize' : ''

        return (
            <ToastContainer
                closeButton={<CloseButton />}
                autoClose={5000}
                style={{ width: 500 }}
                className={minimizeWidth}
            />
        )
    }
}

const mapStateToProps = (state: ToastRootState): ToastProps => {
    return {
        minimizeMenu: state.app.minimizeMenu,
    }
}

export default connect(mapStateToProps)(Toast)
